exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".certificate-drawer--container {\n  width: 30vw;\n  padding: 16px 24px;\n}\n\n.cert-drawer-attr--container {\n  margin-bottom: 12px;\n}\n\n.cert-drawer-attr--label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-navy);\n  margin-bottom: 4px;\n}\n\n.cert-drawer-attr--value {\n  font-size: 14px;\n}", ""]);

